import React from "react";
import { useLang } from "../context/LangContext";

const styleMap = {
  Eingetroffen: "status-eingetroffen",
  "In Bearbeitung": "status-in-bearbeitung",
  "Erneut versendet": "status-erneut",
  Storniert: "status-storniert",
  Abgeschlossen: "status-abgeschlossen",
};

export default function StatusBadge({ status, className = "" }) {
  const { t } = useLang();
  const cls = styleMap[status] || "status-eingetroffen";
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`${cls} ${className} inline-flex items-center text-xs font-medium px-2.5 py-1 border`}
      style={{ borderRadius: 4 }}
    >
      {t(`stats.${status}`)}
    </span>
  );
}
